<template>
    <div v-if="showMessage" class="notification-component">
        <div class="message">
            <img src="/systems/img/appicon.png" width="50" />
            <a class="dismiss" href="#" @click.prevent="dismiss" title="dismiss notification"><icon type="solid" name="faCircleXmark"></icon></a>
            <h3 v-if="message.title">{{message.title}}</h3>
            <p>{{message.message}}</p>
            <a class="link td-btn primary" v-if="showLink" :href="message.link" :title="message.title">Open</a>
            <a class="link td-btn primary" v-if="!showLink" href="#" @click.prevent="dismiss" title="dismiss notification">Dismiss</a>
        </div>
    </div>
</template>

<script>
import script from './NotificationComponent';
    export default script;</script>

<style lang="less">
    @import "./NotificationComponent.less";
</style>